module.exports = __webpack_public_path__ + "static/media/pic6@2x.9e7adaea.png";